/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';

const styles = StyleSheet.create((pd) => ({
  chinaTermsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'stretch',
    width: '100%',
  },
  chinaTermsCheckbox: {
    width: pd.ref.space.spacing50.px,
    height: pd.ref.space.spacing50.px,
    minWidth: pd.ref.space.spacing50.px,
    minHeight: pd.ref.space.spacing50.px,
    flexShrink: 0,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: pd.sys.shape.corner.extra_small.topStart,
  },
  chinaTermsLabel: {
    flex: 1,
    minWidth: 0,
    marginLeft: pd.ref.space.spacing30.px,
  },
}));

export default styles;
